
import { Component, Vue } from 'vue-property-decorator';
import { getGameList, getGameRank } from '@/api/gameList'
import { DOWNLOAD_CLIENT_TYPE } from "../constant";

@Component
export default class ListByPc extends Vue {
  public list = []
  public downloadClientType = DOWNLOAD_CLIENT_TYPE;
  public async init() {
    const {data: {data}} = await getGameList()
    const result = (data || []).splice(0, 6)

    const ids = result.map(item => (item as any).gameId);
    const {data: {data: rankData}} = await getGameRank({
      gameIds: ids.join(','),
      gameType: 7
    })
    this.list = result.map(item => {
      const rankItem = rankData.find(row => row.gameId === item.gameId)
      return {
        ...item,
        rankIndex: rankItem.rankIndex,
        gameLabels: (item.gameLabels || []).splice(0, 3)
      }
    })
  }
  public mounted() {
    this.init()
  }

  public getFile(url) {
    const path = url.split('/').pop();
    return path;
  }
   public handleDownload() {
    this.$emit('start')
  }
}
